export default "__VITE_ASSET__BLZiSXFt__"